// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-audio-wrapper[data-v-7e31b969] {
  width: 100%;
}
.child-1[data-v-7e31b969] {
  grid-area: area-1;
  justify-self: center;
  align-self: start;
}
.child-2[data-v-7e31b969] {
  grid-area: area-2;
  justify-self: start;
  max-width: 94%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  filter: contrast(var(--fontContrast));
}
.child-3[data-v-7e31b969] {
  grid-area: area-3;
  align-self: start;
}
.child-4[data-v-7e31b969] {
  grid-area: area-4;
  align-self: flex-start;
  padding-left: 8px;
  padding-right: 16px;
}
.child-5[data-v-7e31b969] {
  grid-area: area-5;
  justify-self: center;
}
.chat-audio-message[data-v-7e31b969] {
  display: grid;
  grid-template-columns: 48px repeat(3, 1fr);
  grid-template-rows: 1.3fr 0.5fr 0.2fr;
  row-gap: 0px;
  column-gap: 2px;
  grid-template-areas: "area-1 area-2 area-2 area-2" "area-1 area-3 area-3 area-4" "area-5 area-3 area-3 area-4";
  margin-top: 4px;
  margin-bottom: -10px;
}
.chat-audio-message .slider.extra-margin-top[data-v-7e31b969] {
  margin-top: -8px;
}
.chat-audio-message .audio-volume .slider[data-v-7e31b969] {
  width: 50px;
}
.chat-audio-message .audio-time[data-v-7e31b969] {
  margin: auto;
  color: var(--message-grey-color);
  font-size: 1em;
  margin-bottom: 2px;
}
.chat-audio-message .slider[data-v-7e31b969] {
  display: flex;
  margin-top: -16px;
}
.chat-audio-message .aux-download-btn[data-v-7e31b969] {
  position: relative;
  width: 20px;
  height: 20px;
  display: inline-flex;
  background-color: #76a7f3;
  border-radius: 50%;
  border: 1px var(--shifted-circle-border-color) solid;
  margin-top: -37px;
  margin-left: 28px;
  z-index: 100;
}
.chat-audio-message .aux-download-btn i[data-v-7e31b969] {
  position: relative;
  font-size: small;
  top: 3px;
  left: 3px;
  color: white;
}
.forward[data-v-7e31b969] {
  margin-bottom: 0.33em;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatAudioMessage.vue"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,8GAA8G;EAC9G,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;EACpD,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,YAAY;AACd;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".chat-audio-wrapper[data-v-7e31b969] {\n  width: 100%;\n}\n.child-1[data-v-7e31b969] {\n  grid-area: area-1;\n  justify-self: center;\n  align-self: start;\n}\n.child-2[data-v-7e31b969] {\n  grid-area: area-2;\n  justify-self: start;\n  max-width: 94%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  filter: contrast(var(--fontContrast));\n}\n.child-3[data-v-7e31b969] {\n  grid-area: area-3;\n  align-self: start;\n}\n.child-4[data-v-7e31b969] {\n  grid-area: area-4;\n  align-self: flex-start;\n  padding-left: 8px;\n  padding-right: 16px;\n}\n.child-5[data-v-7e31b969] {\n  grid-area: area-5;\n  justify-self: center;\n}\n.chat-audio-message[data-v-7e31b969] {\n  display: grid;\n  grid-template-columns: 48px repeat(3, 1fr);\n  grid-template-rows: 1.3fr 0.5fr 0.2fr;\n  row-gap: 0px;\n  column-gap: 2px;\n  grid-template-areas: \"area-1 area-2 area-2 area-2\" \"area-1 area-3 area-3 area-4\" \"area-5 area-3 area-3 area-4\";\n  margin-top: 4px;\n  margin-bottom: -10px;\n}\n.chat-audio-message .slider.extra-margin-top[data-v-7e31b969] {\n  margin-top: -8px;\n}\n.chat-audio-message .audio-volume .slider[data-v-7e31b969] {\n  width: 50px;\n}\n.chat-audio-message .audio-time[data-v-7e31b969] {\n  margin: auto;\n  color: var(--message-grey-color);\n  font-size: 1em;\n  margin-bottom: 2px;\n}\n.chat-audio-message .slider[data-v-7e31b969] {\n  display: flex;\n  margin-top: -16px;\n}\n.chat-audio-message .aux-download-btn[data-v-7e31b969] {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  background-color: #76a7f3;\n  border-radius: 50%;\n  border: 1px var(--shifted-circle-border-color) solid;\n  margin-top: -37px;\n  margin-left: 28px;\n  z-index: 100;\n}\n.chat-audio-message .aux-download-btn i[data-v-7e31b969] {\n  position: relative;\n  font-size: small;\n  top: 3px;\n  left: 3px;\n  color: white;\n}\n.forward[data-v-7e31b969] {\n  margin-bottom: 0.33em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
